import BiocerticaIdLogoWhite from './biocertica-id-logo-white.png';
import BiocerticaIdLogoBlack from './biocertica-id-logo-black.svg';
import BiocerticaIdLogoDefault from './biocertica-id-logo-default.svg';
import BiocerticaIdLogoBlackVertical from './biocertica-id-logo-with-text-black-vertical.svg';
import BiocerticaIdLogoDefaultVertical from './biocertica-id-logo-with-text-default-vertical.svg';

import BiocerticaLogoBlack from './biocertica-logo-black.svg';
import BiocerticaLogoDefault from './biocertica-logo-default.svg';
import BiocerticaLogoWithTextBlackHorizontal from './biocertica-logo-with-text-black-horizontal.svg';
import BiocerticaLogoWithTextWhiteHorizontal from './biocertica-logo-with-text-white-horizontal.svg';
import BiocerticaLogoWithTextBlackVertical from './biocertica-logo-with-text-black-vertical.svg';
import BiocerticaLogoWithTextDefaultHorizontal from './biocertica-logo-with-text-default-horizontal.svg';
import BiocerticaLogoWithTextDefaultVertical from './biocertica-logo-with-text-default-vertical.svg';

import BiocerticaLogoWhite from './biocertica-white.svg';
import BiocerticaDefault from './biocertica-default.svg';

import BiocerticaLogoBlackDefault from './default.svg';

import BiocerticaLogoOnlyColour from './biocertica-logo-only-colour.svg';

export {
    BiocerticaLogoBlackDefault,
    BiocerticaDefault,
    BiocerticaLogoWhite,
    BiocerticaIdLogoWhite,
    BiocerticaIdLogoBlack,
    BiocerticaIdLogoDefault,
    BiocerticaIdLogoBlackVertical,
    BiocerticaIdLogoDefaultVertical,
    BiocerticaLogoBlack,
    BiocerticaLogoDefault,
    BiocerticaLogoWithTextBlackHorizontal,
    BiocerticaLogoWithTextWhiteHorizontal,
    BiocerticaLogoWithTextBlackVertical,
    BiocerticaLogoWithTextDefaultHorizontal,
    BiocerticaLogoWithTextDefaultVertical,
    BiocerticaLogoOnlyColour,
};
